import React from 'react'
import chunk from 'lodash/chunk'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import { useMenu } from '@monorepo/menu_module'
import { useOfficesList } from '@monorepo/company_module'
import { PhoneLink, WhatsAppLink } from 'App/Components'
import { LinksList } from './LinksList'

type MiddleSectionProps = {
  logoImage: string
}

export const MiddleSection: React.FC<MiddleSectionProps> = ({ logoImage }) => {
  const { data: phones = [] } = useOfficesList({
    select: (data) =>
      data
        .flatMap((office) => office.phones)
        .filter((phone) => phone.isMain)
        .filter(
          (phone, index, self) =>
            index === self.findIndex((p) => p.number === phone.number)
        ),
  })

  const { data: menuItemsColumns = [] } = useMenu('footerLinks', {
    select: (data) => chunk(data, Math.ceil(data.length / 3)),
  })

  return (
    <div className="vc_row wpb_row vc_row-fluid vc_custom_1559292623224 vc_row-has-fill vc_row-o-equal-height vc_row-o-content-middle vc_row-flex vc-row-651680">
      <div className="container et-clearfix">
        <div className="logo-size-normal footer-contacts wpb_column vc_column_container vc_col-sm-12 vc_col-lg-4 vc_col-md-12 vc_col-xs-12 text-align-none vc_col-has-fill vc-column-437649">
          <div
            className="vc_column-inner vc_custom_1559292758492"
            data-480-right="0"
            data-480-768-right="0"
            data-768-1024-right="35"
            data-1024-1280-right="50"
          >
            <div className="wpb_wrapper">
              <div
                id="et-image-589350"
                className="et-image alignnone curtain-left"
                data-curtain="false"
                data-animation-delay="0"
                data-parallax="false"
                data-move="false"
                data-coordinatex="0"
                data-coordinatey="0"
                data-speed="10"
              >
                <img width="342" height="52" src={logoImage} alt="MobiZap" />
              </div>
              <span className="et-gap et-clearfix et-gap-883750" />
              <div
                id="et-icon-box-893709"
                className="title-margin-0 et-icon-box et-item icon-position-left icon-alignment-left hover-none"
                data-parallax="false"
                data-move="false"
                data-coordinatex="0"
                data-coordinatey="0"
                data-speed="10"
              >
                <div className="et-icon-box-inner et-item-inner et-clearfix">
                  <div className="et-icon medium">
                    <span
                      className="el-icon fas fa-headset"
                      style={{ color: 'var(--color-red)' }}
                    />
                  </div>
                  <div className="et-icon-content et-clearfix">
                    <div className="et-icon-box-title">
                      Есть вопросы? Пиши, звони!
                    </div>
                    <div className="et-icon-box-content">
                      {phones.map((phone, idx) => (
                        <div key={idx}>
                          <WhatsAppLink
                            phone={phone.number}
                            className="d-inline text-reset"
                          >
                            <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                          </WhatsAppLink>
                          <PhoneLink
                            className="d-inline text-reset ml-3"
                            phone={phone.number}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <span className="et-gap et-clearfix et-gap-883750" />
              <span className="et-gap et-clearfix et-gap-913975 hide1280" />
            </div>
          </div>
        </div>
        <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-8 vc_col-md-12 vc_col-xs-12 text-align-none vc-column-953833">
          <div className="vc_column-inner ">
            <div className="wpb_wrapper">
              <div className="vc_row wpb_row vc_inner vc_row-fluid vc_column-gap-24 vc_row-o-equal-height vc_row-o-content-top vc_row-flex vc-row-242325">
                {menuItemsColumns.map((items, idx) => (
                  <div
                    key={idx}
                    className="wpb_column vc_column_container vc_col-sm-4 vc_col-lg-4 vc_col-md-4 vc_col-xs-12"
                  >
                    <LinksList
                      title={idx === 0 ? 'Ссылки' : undefined}
                      items={items}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
